/**
 * Copyright (C) 2021 Prosperia Salud, S.A. DE C.V. info@prosperia.health.
 * All rights reserved
 * DO NOT REDISTRIBUTE
 * The software MAY NOT be rewritten or refactored by any means. The code MAY
 * NOT be packaged and redistributed by any means without prior written
 * permission from the author.
 */
/// /// EXTERNAL /// ///
// mui //
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import SignalWifiBadIcon from '@mui/icons-material/SignalWifiBad';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import TerminalIcon from '@mui/icons-material/Terminal';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// third party libraries //
import imageCompression from 'browser-image-compression';
// utils //
import { Progress } from './constants';

export const OPTICAL_DISC_DISEASE = 'suspicious_cup_disc_ratio';
const info = {
  age_related_macular: 'Degeneración macular asociada a la edad',
  macular_edema: 'Edema macular',
  other_retina: 'Lesiones en retina',
  pathological_myopia: 'Miopía patológica',
  retinopathy: 'Retinopatía diabética',
};

const diseasesValues = (diseasesKey) => {
  let diseases = [];
  Object.keys(diseasesKey).forEach((key) => {
    if (key !== 'severe_case') diseases = [...diseases, info[key]];
  });
  return diseases;
};

export const isProduction = process.env.REACT_APP_STAGE === 'production';

/**
 * Base URL of the authentication app, without trailing slash.
 * Falls back to the current origin when REACT_APP_AUTH_URL is not set.
 */
export const getAuthBaseUrl = () => process.env.REACT_APP_AUTH_URL || window.location.origin;

export const removeData = () => {
  window.location.href = `${getAuthBaseUrl()}/login`;
};

export const getPath = (location) => {
  const pathName = location.pathname;
  const index = pathName.lastIndexOf('/');
  return pathName.slice(0, index);
};

export const isNotEmpty = (value) => {
  if (value) return true;
  return false;
};

export const isPwa = () => ['fullscreen', 'standalone', 'minimal-ui'].some(
  (displayMode) => window.matchMedia(`(display-mode: ${displayMode})`).matches,
);

export const getColor = (palette, value) => {
  if (!value) return '';
  if (value === 'success') return palette.success.main;
  if (value === 'error') return palette.error.main;
  if (value === 'warning') return palette.warning.main;
  if (value === 'primary') return palette.primary.main;
  return value;
};

export const hasDiseases = (diseases, excludeDiseases) => {
  let find = false;
  Object.entries(diseases).forEach((data) => {
    const key = data[0];
    const value = data[1];
    if (value) {
      if (!excludeDiseases || excludeDiseases.length === 0) {
        find = true;
      } else if (excludeDiseases.filter((exclude) => exclude === key).length === 0) {
        find = true;
      }
    }
  });
  return find;
};

export const diseasesSideEye = (photos) => {
  let diseasesKey = {};
  photos.forEach((photo) => {
    const { diseases } = photo;
    Object.entries(diseases).forEach((entry) => {
      const [key, value] = entry;
      if (value) if (!diseasesKey[key]) diseasesKey = { ...diseasesKey, [key]: value };
    });
  });
  return diseasesValues(diseasesKey);
};

export const compressBase64 = (file, quality) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  const options = {
    initialQuality: quality,
    useWebWorker: false,
  };
  imageCompression(file, options).then((compressed) => {
    reader.readAsDataURL(compressed);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
});

export const convertImages = async (data, quality, interactionId) => {
  const promises = data.map(async (file) => {
    const { name } = file;
    const base64 = await compressBase64(file, quality);
    const image = {
      name,
      image_base: base64,
      interaction_id: interactionId,
    };
    return image;
  });

  return Promise.all(promises);
};

export const convertBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (data) => reject(data);
});

export const convertDateToUTC = (date) => new Date(
  date.getUTCFullYear(),
  date.getUTCMonth(),
  date.getUTCDate(),
  date.getUTCHours(),
  date.getUTCMinutes(),
  date.getUTCSeconds(),
);

export const formatDate = (data) => {
  const year = data.getFullYear();
  const month = `${data.getMonth() + 1}`.padStart(2, '0');
  const date = `${data.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${date}`;
};

export const adjutsDateWithoutLocalTZ = (date) => {
  const adjust = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return adjust;
};
export const getProcessIcon = (value, style) => {
  switch (value) {
  case Progress.ERROR_UPLOADING_IMAGES:
    return (
      <SyncProblemIcon
        sx={style}
      />
    );
  case Progress.ERROR_NERWORK:
    return (
      <SignalWifiBadIcon
        sx={style}
      />
    );
  case Progress.ERROR_MODELS:
    return (
      <RunningWithErrorsIcon
        sx={style}
      />
    );
  case Progress.LOCKED:
    return (
      <LockOutlinedIcon
        sx={style}
      />
    );
  default:
    return (
      <TerminalIcon
        sx={style}
      />
    );
  }
};
